import React, { useEffect, useState } from 'react';
// import './menuiteams.css';
import Modal from 'react-modal';
import { ShoppingCart } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

Modal.setAppElement('#root');
const WaitermenuIteams = ({ parentId }) => {
    const [dishes, setDishes] = useState([]);
    const [filteredDishes, setFilteredDishes] = useState([]);
    const [quantities, setQuantities] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isVegSelected, setIsVegSelected] = useState(false);
    const [isNonVegSelected, setIsNonVegSelected] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedDish, setSelectedDish] = useState(null);
    const [cartItems, setCartItems] = useState([]);
    const [isHovered, setIsHovered] = useState(false);
    const navigate = useNavigate();
    const [enable, setEnable] = useState([]);
    const [cartData, setCartData] = useState({ cartItems: [] });
    const totalPrice = cartItems.reduce((acc, item) => {
        return acc + item.price * item.quantity * 0.9;
    }, 0);


    const [isOn, setIsOn] = useState(false);
    const handleToggle = () => {
        setIsOn(prev => !prev);
    };



    const addToCart = async (item, quantity = 1) => {
        const vendorId = localStorage.getItem("vendorId");
        const token = localStorage.getItem("authToken");
        const seatingId = localStorage.getItem("seatingId");
        const tableCode = localStorage.getItem("tableCode");

        if (!seatingId || !tableCode) {
            console.error("❌ Seating ID or Table Code not found in localStorage");
            return;
        }

        // ✅ tableCode as query param
        const apiUrl = `https://backend.maamaas.com/food/api/cart/waiter-order/${vendorId}/${seatingId}?tableCode=${tableCode}`;

        const data = [{ dishId: item.dishId, quantity }];

        try {
            const response = await axios.post(apiUrl, data, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
            });

            if (response.status === 200) {
                // ✅ Refresh cart data from API after adding
                await fetchCartData();

                // ✅ Show temporary modal
                setIsModalOpen(true);
                setTimeout(() => {
                    if (!isHovered) setIsModalOpen(false);
                }, 2000);

            } else {
                console.error('Failed to add item to cart:', response.data);
                alert('Failed to add item to cart');
            }
        } catch (error) {
            console.error('Error adding item to cart:', error);
            if (error.response) {
                if (error.response.status === 500) alert('Server Error. Please try again later.');
                else if (error.response.status === 404) alert('Item not found. Please try again.');
                else alert(`Error: ${error.response.data}`);
            } else {
                alert('An unexpected error occurred. Please try again.');
            }
        }
    };





    useEffect(() => {
        const fetchData = async () => {
            const vendorId = localStorage.getItem("vendorId");
            const token = localStorage.getItem("authToken");

            if (!vendorId) {
                console.warn("⚠️ vendorId not found in localStorage");
                setError(new Error("vendorId missing"));
                setLoading(false);
                return;
            }

            if (!token) {
                console.warn("⚠️ authToken not found in localStorage");
                setError(new Error("authToken missing"));
                setLoading(false);
                return;
            }

            try {
                const response = await fetch(
                    `https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`,
                    {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'application/json',
                            'Accept': 'application/json',
                        },
                    }
                );

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const data = await response.json();
                console.log('API Data:', data);

                const dishData = Array.isArray(data) ? data : data.data || [];
                console.log('Dish Data:', dishData);

                const validDishData = dishData.filter(item => item !== null && item !== undefined);
                console.log('Valid Dish Data:', validDishData);

                const filteredData = validDishData.filter(item => {
                    const parentCheck = parentId ? Number(item.parentId) === Number(parentId) : Number(item.parentId) !== 0;
                    const statusCheck = item.menuStatus === "Enable";
                    const quantityCheck = Number(item.balanceQuantity) > 0;
                    return parentCheck && statusCheck && quantityCheck;
                });

                console.log('Filtered Dishes (balanceQuantity > 0):', filteredData);
                setDishes(filteredData);
                setFilteredDishes(filteredData);
            } catch (error) {
                console.error('Error fetching data:', error);
                setError(error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [parentId]);

    const handleFilterClick = (type) => {
        if (type === 'Veg') {
            setIsVegSelected(true);
            setIsNonVegSelected(false);
            setFilteredDishes(dishes.filter(dish => dish.tag === 'Veg'));
        } else if (type === 'Non-Veg') {
            setIsVegSelected(false);
            setIsNonVegSelected(true);
            setFilteredDishes(dishes.filter(dish => dish.tag === 'Non_Veg'));
        }
    };

    const authToken = localStorage.getItem("authToken");
    const vendorId = localStorage.getItem("vendorId");

    const fetchCartData = async () => {
        if (!authToken || !vendorId) return;

        try {
            const response = await axios.get(
                `https://backend.maamaas.com/food/api/cart/vendor/${vendorId}`,
                { headers: { Authorization: `Bearer ${authToken}` } }
            );

            setCartData(response.data);

            const initialQuantities = {};
            if (response.data.cartItems) {
                response.data.cartItems.forEach(item => {
                    initialQuantities[item.dishId] = item.quantity;
                });
            }
            setQuantities(initialQuantities);

        } catch (err) {
            console.error("Error fetching cart:", err);
        }
    };



    // Assume cartData is the full cart object from API
    // {
    //   cartId: 52,
    //   cartItems: [...]
    // }

    const increaseQuantity = async (dishId) => {
        const token = localStorage.getItem("authToken");
        const vendorId = localStorage.getItem("vendorId");
        if (!token || !vendorId) return alert("Auth token or vendorId missing");

        if (!cartData || !cartData.cartItems) {
            alert("Cart is empty or not loaded yet.");
            return;
        }

        const cartItem = cartData.cartItems.find(item => item.dishId === dishId);
        if (!cartItem) {
            alert("Item not found in cart. Please add it first.");
            return;
        }

        const newQty = (quantities[dishId] || 0) + 1;

        // Correct API URL with vendorId and cartId
        const apiUrl = `https://backend.maamaas.com/food/api/cart/update/cart/${vendorId}/${cartData.cartId}?dishId=${dishId}&quantity=${newQty}`;

        console.log("API URL:", apiUrl);

        try {
            const response = await axios.put(apiUrl, null, {
                headers: { Authorization: `Bearer ${token}` }
            });

            console.log("API Response:", response.data);

            // Update state
            setQuantities(prev => ({ ...prev, [dishId]: newQty }));
            setCartData(prev => ({
                ...prev,
                cartItems: prev.cartItems.map(item =>
                    item.dishId === dishId ? { ...item, quantity: newQty } : item
                )
            }));
            setIsModalOpen(true);
            setTimeout(() => {
                if (!isHovered) setIsModalOpen(false);
            }, 2000);
        } catch (err) {
            console.error("API Error:", err.response ? err.response.data : err);
            alert("Unable to update quantity for dishId: " + dishId);
        }
    };




    const decreaseQuantity = async (dishId) => {
        const token = localStorage.getItem("authToken");
        const vendorId = localStorage.getItem("vendorId");
        const currentQty = quantities[dishId] || 0;
        if (currentQty === 0) return;

        if (!cartData || !cartData.cartItems) {
            alert("Cart is empty or not loaded yet.");
            return;
        }

        const cartItem = cartData.cartItems.find(item => item.dishId === dishId);
        if (!cartItem) return alert("Item not found");

        const newQty = currentQty - 1;

        // Correct API URL with vendorId and cartId
        const apiUrl = `https://backend.maamaas.com/food/api/cart/update/cart/${vendorId}/${cartData.cartId}?dishId=${dishId}&quantity=${newQty}`;

        console.log("=== Decrease Quantity API Call ===");
        console.log("dishId:", dishId);
        console.log("newQty:", newQty);
        console.log("cartId:", cartData.cartId);
        console.log("API URL:", apiUrl);

        try {
            const response = await axios.put(apiUrl, null, {
                headers: { Authorization: `Bearer ${token}` }
            });

            console.log("API Response:", response.data);

            setQuantities(prev => ({ ...prev, [dishId]: newQty > 0 ? newQty : 0 }));
            setCartData(prev => ({
                ...prev,
                cartItems: newQty > 0
                    ? prev.cartItems.map(item =>
                        item.dishId === dishId ? { ...item, quantity: newQty } : item
                    )
                    : prev.cartItems.filter(item => item.dishId !== dishId)
            }));
            setIsModalOpen(true);
            setTimeout(() => {
                if (!isHovered) setIsModalOpen(false);
            }, 2000);
        } catch (err) {
            console.error("API Error:", err.response ? err.response.data : err);
            alert("Unable to update quantity for dishId: " + dishId);
        }
    };


    useEffect(() => {
        fetchCartData();
    }, [authToken, vendorId]);




    const handleViewCartClick = () => {
        navigate('/tableCart');
    };

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error loading dishes: {error.message}</div>;
    }

    return (
        <div style={{ marginTop: '100px' }} className='menuiteams-data'>
            <div
                style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "1rem",
                    marginBottom: "1rem",
                    justifyContent: "center",
                }}
            >
                <style>
                    {`
                        @media (max-width: 768px) {
                            .offers-containers {
                                grid-template-columns: repeat(2, 1fr) !important;
                                gap: 15px !important;
                            }
                            .offers-cards {
                                width: 100% !important;
                                max-width: 100% !important;
                            }
                            .responsive-button-group {
                                flex-direction: column !important;
                                align-items: center !important;
                            }
                            .responsive-button {
                                width: 90% !important;
                                text-align: center;
                            }
                            .custom-switch-wrapper {
                                margin-top: 10px;
                                width: 90% !important;
                            }
                        }
                        
                        @media (max-width: 480px) {
                            .offers-containers {
                                grid-template-columns: 1fr !important;
                            }
                            .offers-cards {
                                margin: 0 auto !important;
                            }
                            .card-body {
                                padding: 10px !important;
                            }
                            .card-title {
                                font-size: 18px !important;
                            }
                        }
                        
                        @media (max-width: 320px) {
                            .offers-cards {
                                width: 95% !important;
                            }
                            .card-body {
                                padding: 8px !important;
                            }
                            .card-title {
                                font-size: 16px !important;
                            }
                        }
                        
                        .custom-switch {
                            position: relative;
                            display: inline-block;
                            width: 100px;
                            height: 35px;
                        }
                        
                        .custom-switch input {
                            opacity: 0;
                            width: 0;
                            height: 0;
                        }
                        
                        .custom-slideryy {
                            position: absolute;
                            cursor: pointer;
                            transition: 0.4s;
                            font-weight: bold;
                            font-size: 14px;
                            color: #000;
                            text-align: center;
                            line-height: 35px;
                            width: 100px;
                            height: 40px;
                            border-radius: 5px;
                            background-color: rgb(217, 217, 217);
                        }
                        
                        .custom-slideryy::before {
                            content: "";
                            position: absolute;
                            height: 16px;
                            width: 16px;
                            left: 3px;
                            top: 10px;
                            background-color: #000;
                            transition: 0.4s;
                            border-radius: 50%;
                        }
                        
                        .custom-slideryy.veg::before {
                            background-color: green;
                        }
                        
                        .custom-slideryy.non-veg::before {
                            background-color: red;
                        }
                        
                        .custom-switch input:checked + .custom-slideryy::before {
                            transform: translateX(60px);
                        }
                    `}
                </style>

                <div className="responsive-button-group menu-responsive-buttons-code" style={{ display: "flex", flexDirection: "row", gap: "10px", justifyContent: "center", alignItems: "center" }}>


                    <div className="custom-switch-wrapper" style={{ position: "relative", top: "-12px", left: "-20px" }}>
                        <label className="custom-switch">
                            <input
                                type="checkbox"
                                checked={isVegSelected}
                                onChange={() => handleFilterClick(isVegSelected ? "Non-Veg" : "Veg")}
                            />
                            <span className={`custom-slideryy ${isVegSelected ? "veg" : "non-veg"}`}>
                                {isVegSelected ? "Veg" : "Non-Veg"}
                            </span>
                        </label>
                    </div>
                </div>
            </div>

            <div className="offers-containers" style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
                gap: '20px',
                padding: '20px',
                marginTop: '7px'
            }}>
                {filteredDishes.map((item) => (
                    <div key={item.dishId} className="offers-cards" style={{
                        width: '100%',
                        maxWidth: '300px',
                        margin: '0 auto',
                        borderRadius: '10px',
                        overflow: 'hidden',
                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
                    }}>
                        <div className="inner-box" style={{ position: 'relative' }}>
                            {/* <div
                                style={{
                                    position: 'absolute',
                                    top: '5px',
                                    left: '8%',
                                    transform: 'translateX(-50%)',
                                    height: '33px',
                                    width: '33px',
                                    backgroundColor: 'rgb(253 1 0)',
                                    color: '#fff',
                                    borderRadius: '10px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontWeight: 'bold',
                                    fontSize: '12px',
                                    zIndex: 1
                                }}
                            >
                                10%
                            </div> */}

                            {item.dishImage ? (
                                <img
                                    src={item.dishImage}
                                    alt="Dish"
                                    className="offer-image"
                                    style={{ width: '100%', height: '200px', objectFit: 'cover' }}
                                />
                            ) : (
                                <img
                                    src="default-image.jpg"
                                    alt="Default"
                                    className="offer-image"
                                    style={{ width: '100%', height: '200px', objectFit: 'cover' }}
                                />
                            )}
                        </div>

                        <div
                            className="card-body"
                            style={{
                                marginTop: '8px',
                                padding: '15px',
                                borderRadius: '10px',
                                backgroundColor: '#fff',
                            }}
                        >
                            <h5 className="card-title text-dark text-center" style={{ fontSize: '20px', marginBottom: '10px' }}>
                                {item.dishName}
                            </h5>
                            <span className="d-flex justify-content-between" style={{ color: 'black' }}>
                                <span>
                                    <span style={{ position: 'relative', fontSize: '21px', color: "gray" }}>
                                        <i className="fa-solid fa-indian-rupee-sign" style={{ fontSize: '15px' }}></i>
                                        {item.price}
                                        <span style={{
                                            content: '',
                                            position: 'absolute',
                                            top: '15px',
                                            left: 0,
                                            width: '100%',
                                            borderTop: '1px solid black',
                                        }} />
                                    </span>

                                    <span style={{ fontSize: '20px', position: 'relative', marginLeft: '15px' }}>
                                        <i className="fa-solid fa-indian-rupee-sign" style={{ fontSize: "15px" }}></i>
                                        {item.effectivePrice
                                        }
                                    </span>
                                </span>

                            </span>

                            <br></br>


                            {cartData.cartItems?.some(ci => ci.dishId === item.dishId) || quantities[item.dishId] > 0 ? (
                                // Show increment/decrement if in cart OR just added
                                <div
                                    className="d-flex justify-content-between align-items-center border p-2 mt-2"
                                    style={{
                                        borderRadius: '50px',
                                        backgroundColor: '#b15dc6',
                                        width: '80%',
                                        height: '37px',
                                        marginLeft: 'auto',
                                        marginRight: 'auto',
                                    }}
                                >
                                    <button
                                        onClick={() => decreaseQuantity(item.dishId)}
                                        style={{
                                            width: '40px',
                                            height: '40px',
                                            fontSize: '25px',
                                            fontWeight: 'bold',
                                            color: '#fff',
                                            marginTop: '-10px',
                                            border: 'none',
                                            background: 'none',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        -
                                    </button>
                                    <span
                                        style={{
                                            fontSize: '25px',
                                            fontWeight: 'bold',
                                            minWidth: '40px',
                                            textAlign: 'center',
                                            color: '#fff',
                                        }}
                                    >
                                        {quantities[item.dishId] || 1}
                                    </span>
                                    <button
                                        onClick={() => increaseQuantity(item.dishId)}
                                        style={{
                                            width: '40px',
                                            height: '40px',
                                            fontSize: '25px',
                                            fontWeight: 'bold',
                                            color: '#fff',
                                            marginTop: '-10px',
                                            border: 'none',
                                            background: 'none',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        +
                                    </button>
                                </div>
                            ) : (
                                // Add To Cart button
                                <button
                                    className="btn mt-2 d-block mx-auto"
                                    onClick={async () => {
                                        // Immediately set quantity in UI
                                        setQuantities(prev => ({ ...prev, [item.dishId]: 1 }));

                                        // Call addToCart and refresh cartData
                                        await addToCart(item, 1);
                                    }}
                                    style={{
                                        background: "#b15dc6",
                                        color: "#fff",
                                        width: "80%",
                                        borderRadius: "50px",
                                        padding: "8px 0",
                                    }}
                                >
                                    Add To Cart
                                </button>
                            )}
                        </div>
                    </div>
                ))}
            </div>

            <Modal
                isOpen={isModalOpen}
                onRequestClose={() => setIsModalOpen(false)}
                contentLabel="Add to Cart"
                shouldCloseOnOverlayClick={false}
                shouldCloseOnEsc={false}
                style={{
                    overlay: {
                        backgroundColor: "transparent",
                        pointerEvents: "none",
                    },
                    content: {
                        pointerEvents: "auto",
                        position: "sticky",
                        bottom: "20px",
                        top: "620px",
                        left: "30%",
                        width: "90%",
                        maxWidth: "500px",
                        border: "none",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                        padding: "10px",
                        height: "auto",
                        borderRadius: "10px",
                    },
                }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "10px",
                        width: "100%",
                        fontWeight: "bold",
                        color: "#333",
                        borderRadius: "10px",
                        height: "auto",
                        border: "2px solid #b15cd6",
                        flexWrap: "wrap"
                    }}
                >
                    <ShoppingCart style={{ fontSize: "30px", color: "#b15dc6", marginRight: "10px" }} />

                    {/* Total Items */}
                    <div style={{ marginRight: "10px", fontSize: "18px" }}>
                        ({cartData.cartItems?.reduce((acc, item) => acc + (quantities[item.dishId] || item.quantity || 0), 0)}) Items
                    </div>

                    {/* Total Price */}
                    {/* Total Price */}
                    <div style={{ marginRight: "10px", fontSize: "18px" }}>
                        Total: ₹
                        {cartData.cartItems
                            ?.reduce((acc, item) => {
                                // Get quantity: use quantities state if available, otherwise API quantity
                                const quantity = quantities[item.dishId] ?? item.quantity ?? 0;

                                // Get price: parseFloat safely, fallback to 0
                                const price = parseFloat(item.effectivePrice ?? item.price ?? 0);

                                return acc + price * quantity;
                            }, 0)
                            .toFixed(2)}
                    </div>


                    <button
                        style={{
                            borderRadius: "50px",
                            background: "#b15dc6",
                            color: "#fff",
                            padding: "8px 16px",
                            border: "none",
                            cursor: "pointer",
                            marginTop: "5px",
                            width: "100%",
                            maxWidth: "150px"
                        }}
                        onClick={handleViewCartClick}
                    >
                        View Cart
                    </button>
                </div>
            </Modal>
        </div>
    );
};

export default WaitermenuIteams;